import { Grid, useEventCallback } from '@mui/material';
import { Fragment, memo } from 'react';
import { FormikErrors, FormikTouched } from 'formik';
import { SectionVM } from 'civil-status/view-models/step-form';
import PmiTextField from 'shell/components/shared/text-field';
import { ItemVM } from 'shell/view-models/item';
import ListAnsc from '../../../../../../shared/list-ansc';
import { IDChangeSurname } from 'civil-status/constants/id-change-surname';

interface GeneralDataGannmoProps {
  disabled?: boolean;
  values?: SectionVM;
  errors?: FormikErrors<SectionVM>;
  touched?: FormikTouched<SectionVM>;
  onChange: (key: keyof SectionVM, value: SectionVM[keyof SectionVM]) => void;
  onChanges: (values: SectionVM) => void;
  configuration?: string;
  tipoEvento?: string;
}

const GeneralDataGannmoComponent = ({
  disabled = false,
  values,
  errors,
  touched,
  onChange,
  onChanges,
}: GeneralDataGannmoProps): React.ReactElement => {
  const handleListChangeSurname = useEventCallback((item?: ItemVM) => {
    onChanges({
      ...(values || {}),
      changeSurname: item?.id?.toString() || '',
      oldSurnameRegistered: undefined,
      newSurnameRegistered: undefined,
      oldNameRegistered: undefined,
      newNameRegistered: undefined,
    });
  });

  return (
    <Grid item xs={12} container spacing={2}>
      <Grid item xs={12} md={7}>
        <ListAnsc
          label="Tipo cambio nome"
          idDominio="39"
          value={values?.changeSurname || ''}
          onChange={handleListChangeSurname}
          disabled={disabled}
          error={Boolean(errors?.changeSurname) && touched?.changeSurname}
          required
          betweenFrom={6}
          betweenTo={8}
        />
      </Grid>
      {values?.changeSurname === IDChangeSurname.nuovoCognome ||
      values?.changeSurname === IDChangeSurname.nuovoCognomeNome ? (
        <Fragment>
          <Grid item xs={12} md={6}>
            <PmiTextField
              label="Vecchio cognome intestatario *"
              aria-label="Vecchio cognome intestatario"
              id="oldSurnameRegistered"
              name="oldSurnameRegistered"
              fullWidth
              type="text"
              variant="outlined"
              value={values?.oldSurnameRegistered || ''}
              onChange={(event) => {
                onChange('oldSurnameRegistered', event.target.value);
              }}
              error={touched?.oldSurnameRegistered && Boolean(errors?.oldSurnameRegistered)}
              helperText={errors?.oldSurnameRegistered}
              disabled={disabled}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <PmiTextField
              label="Nuovo cognome intestatario *"
              aria-label="Nuovo cognome intestatario"
              id="newSurnameRegistered"
              name="newSurnameRegistered"
              fullWidth
              type="text"
              variant="outlined"
              value={values?.newSurnameRegistered || ''}
              onChange={(event) => {
                onChange('newSurnameRegistered', event.target.value);
              }}
              error={touched?.newSurnameRegistered && Boolean(errors?.newSurnameRegistered)}
              helperText={errors?.newSurnameRegistered}
              disabled={disabled}
            />
          </Grid>
        </Fragment>
      ) : undefined}
      {values?.changeSurname === IDChangeSurname.nuovoNome ||
      values?.changeSurname === IDChangeSurname.nuovoCognomeNome ? (
        <Fragment>
          <Grid item xs={12} md={6}>
            <PmiTextField
              label="Vecchio nome intestatario *"
              aria-label="Vecchio nome intestatario"
              id="oldNameRegistered"
              name="oldNameRegistered"
              fullWidth
              type="text"
              variant="outlined"
              value={values?.oldNameRegistered || ''}
              onChange={(event) => {
                onChange('oldNameRegistered', event.target.value);
              }}
              error={touched?.oldNameRegistered && Boolean(errors?.oldNameRegistered)}
              helperText={errors?.oldNameRegistered}
              disabled={disabled}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <PmiTextField
              label="Nuovo nome intestatario *"
              aria-label="Nuovo nome intestatario"
              id="newNameRegistered"
              name="newNameRegistered"
              fullWidth
              type="text"
              variant="outlined"
              value={values?.newNameRegistered || ''}
              onChange={(event) => {
                onChange('newNameRegistered', event.target.value);
              }}
              error={touched?.newNameRegistered && Boolean(errors?.newNameRegistered)}
              helperText={errors?.newNameRegistered}
              disabled={disabled}
            />
          </Grid>
        </Fragment>
      ) : undefined}
    </Grid>
  );
};

GeneralDataGannmoComponent.displayName = 'Form General Data Gannmo component';

const GeneralDataGannmo = memo(GeneralDataGannmoComponent);

export default GeneralDataGannmo;
